import { Link } from "react-router-dom";

import Button from "@/components/button/button";
import Icon from "@/components/icon/icon";
import Logo from "@/components/logo/logo";

import styles from "./navigation.module.css";

interface NavigationMobileHeaderProps {
  toggleMobileMenu: () => void;
}

export default function NavigationMobileHeader({
  toggleMobileMenu,
}: NavigationMobileHeaderProps) {
  return (
    <div className={styles.mobileHeader}>
      <Link to="/" className={styles.mobileLogo}>
        <Logo />
      </Link>
      <Button
        onClick={toggleMobileMenu}
        variant="primary"
        className={styles.mobileToggleButton}
      >
        <Icon name="menu" />
      </Button>
    </div>
  );
}
